import React, {useEffect, useState} from "react";
import Table from "../../common/Table";

const BalanceDataTables = ({name, data, summary}) => {
    const columns = {
        "summary": [
            {path: "id", label: "شماره"},
            {path: "semester", label: "سمستر"},
            {path: "fee", label: "فیس"},
            {path: "discount", label: "تخفیف"},
            {path: "paid", label: "پرداخت"},
            {path: "remaining", label: "باقی مانده"}
        ],
        "payments": [
            {path: "id", label: "شماره"},
            {path: "payment_date", label: "تاریخ"},
            {path: "bank_ref_no", label: "ریفرنس نمبر"},
            {path: "account", label: "حساب"},
            {path: "remark", label: "ملاحظه"},
            {path: "amount", label: "مبلغ"},
        ],
        "discounts": [
            {path: "id", label: "شماره"},
            {path: "discount_type", label: "نوع"},
            {path: "class_desc", label: "صنف"},
            {path: "issue_date", label: "تاریخ"},
            {path: "remark", label: "ملاحظه"},
            {path: "amount", label: "مبلغ"},
        ],
    };

    return (
        <div className="print-table-area">
            <Table data={data} columns={columns[name]} summary={summary}/>
        </div>
    );
};

export default BalanceDataTables;
